module.exports = __webpack_public_path__ + "img/kopsurat_sari_asih.10488ca3.png";